"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const array_1 = require("./array");
const date_1 = require("./date");
const fallback_1 = require("./fallback");
const map_1 = require("./map");
const set_1 = require("./set");
/* APPLICATORS */
//TODO: Add support for TypedArray
const Applicators = { Array: array_1.default, Date: date_1.default, fallback: fallback_1.default, Map: map_1.default, Set: set_1.default };
/* EXPORT */
exports.default = Applicators;
